<template>
  <div>
    <InputMoney
        v-model="discount"
        label="Desconto"
        name="discount"
        :errors="errors"
    />
  </div>
</template>

<script>
import InputMoney from "../inputs/InputMoney.vue";

export default {
  name: "DescontoCategoria",
  components: {InputMoney},
  data() {
    return {
      errors: [],
      discount: null,
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/rules/DescontoCategoria.vue